import * as yup from 'yup'

export const salutationValidator = yup
    .string()
    .trim()
    .required('Please enter a title')
    .min(2, 'Please enter a valid title')
export const firstNameValidator = yup
    .string()
    .trim()
    .required('Please enter your first name')
    .min(2, 'Please enter a valid first name')
export const lastNameValidator = yup
    .string()
    .trim()
    .required('Please enter your last name')
    .min(2, 'Please enter a valid last name')
export const middleNameValidator = yup.string().trim().optional()

export const nameSchema = yup
    .object({
        salutation: salutationValidator,
        firstName: firstNameValidator,
        middleName: middleNameValidator,
        lastName: lastNameValidator,
    })
    .required()

export type NameFormValues = yup.InferType<typeof nameSchema>
